// frontend/src/pages/Complaint.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Complaint.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

function Complaint({ user, darkMode, toggleTheme }) {
  const [text, setText] = useState('');
  const [photo, setPhoto] = useState(null);
  const [photoPreview, setPhotoPreview] = useState(null);
  const [sending, setSending] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPhoto(file);
      const reader = new FileReader();
      reader.onloadend = () => setPhotoPreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!text.trim()) {
      setError('Опишите проблему');
      return;
    }

    setSending(true);
    setError('');

    try {
      const formData = new FormData();
      formData.append('employee_id', user.id);
      formData.append('company_id', user.company_id);
      formData.append('complaint_text', text);
      if (photo) {
        formData.append('photo', photo);
      }

      await axios.post(`${API_URL}/api/complaints`, formData);
      setSuccess(true);
      setText('');
      setPhoto(null);
      setPhotoPreview(null);
    } catch (err) {
      setError('Ошибка отправки. Попробуйте позже.');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="page complaint-page">
      {/* Шапка */}
      <header className="complaint-header">
        <button className="btn btn-sm btn-outline" onClick={() => navigate('/menu')}>
          ← Назад
        </button>
        <h1 className="page-title">💬 Жалоба</h1>
        <button className="btn btn-sm btn-outline theme-toggle" onClick={toggleTheme}>
          {darkMode ? '☀️' : '🌙'}
        </button>
      </header>

      {success ? (
        <div className="success-card card">
          <div className="success-icon">✅</div>
          <h2>Жалоба отправлена!</h2>
          <p className="text-light">Мы рассмотрим её в ближайшее время</p>
          <button className="btn" onClick={() => setSuccess(false)} style={{ marginTop: 16 }}>
            Отправить ещё
          </button>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="complaint-form card">
          <label className="input-label">Опишите проблему</label>
          <textarea
            className="input complaint-textarea"
            placeholder="Что случилось? Опишите подробно..."
            value={text}
            onChange={(e) => setText(e.target.value)}
            rows={5}
          />

          <label className="input-label" style={{ marginTop: 16 }}>
            Фото (необязательно)
          </label>
          <div className="photo-upload">
            <input
              type="file"
              accept="image/*"
              onChange={handlePhotoChange}
              id="photo-input"
              className="photo-input-hidden"
            />
            <label htmlFor="photo-input" className="photo-label">
              {photoPreview ? (
                <img src={photoPreview} alt="Предпросмотр" className="photo-preview" />
              ) : (
                <div className="photo-placeholder">
                  <span>📷</span>
                  <span>Нажмите чтобы добавить фото</span>
                </div>
              )}
            </label>
            {photo && (
              <button 
                type="button" 
                className="btn btn-sm btn-outline" 
                onClick={() => { setPhoto(null); setPhotoPreview(null); }}
                style={{ marginTop: 8 }}
              >
                Удалить фото
              </button>
            )}
          </div>

          {error && <div className="error-message">{error}</div>}

          <button 
            type="submit" 
            className={`btn complaint-submit ${sending ? 'loading' : ''}`}
            disabled={sending}
            style={{ marginTop: 20, width: '100%' }}
          >
            {sending ? <span className="spinner"></span> : 'Отправить жалобу'}
          </button>
        </form>
      )}
    </div>
  );
}

export default Complaint;